export default __webpack_public_path__ + "static/media/tooltip.1aa32f13.svg";